import { apiClient } from './client';
import type {
  RegisterTenantRequest,
  RegisterTenantResponse,
  TenantResponse,
} from './types';

export interface PublicSignupStatus {
  enabled: boolean;
}

/** GET /api/public/signup-status — gate público; un error de transporte se trata como cerrado en la ruta. */
export async function getPublicSignupStatus(): Promise<PublicSignupStatus> {
  const { data } = await apiClient.get<PublicSignupStatus>('/public/signup-status');
  return data;
}

/** POST /api/tenants — endpoint anónimo (signup). Crea tenant + primer TenantAdmin. */
export async function registerTenant(body: RegisterTenantRequest): Promise<RegisterTenantResponse> {
  const { data } = await apiClient.post<RegisterTenantResponse>('/tenants', body);
  return data;
}

/** GET /api/tenants/:id — requiere X-Tenant-Id matching `id`. */
export async function getTenant(id: string): Promise<TenantResponse> {
  const { data } = await apiClient.get<TenantResponse>(`/tenants/${id}`);
  return data;
}

/** PUT /api/tenants/:id — update name + email. */
export async function updateTenant(id: string, body: { name: string; email: string }): Promise<TenantResponse> {
  const { data } = await apiClient.put<TenantResponse>(`/tenants/${id}`, body);
  return data;
}
